import PrCardComponent from './pr-card';

export default PrCardComponent;